import React, { useEffect, useRef } from "react";
import styles from "./SearchDropdown.module.scss";
import { IoSearch } from "react-icons/io5";
import SearchDropdownItem from "./SearchDropdownItem";

const SearchDropdown = ({
  data,
  value,
  setInputValue,
  handleSelectItem,
  setShowBtn,
}) => {
  // const [searchValue, setSearchValue] = useState('');

  const filteredChats = data?.filter((item) =>
    item.name.toLowerCase().includes(value.toLowerCase())
  );

  const dropdownRef = useRef(null);

  const handleCloseDropDown = (e) => {
    if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
      setShowBtn(true);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleCloseDropDown);
    return () => {
      document.removeEventListener("mousedown", handleCloseDropDown);
    };
  }, []);

  return (
    <div
      ref={dropdownRef}
      onClick={handleCloseDropDown}
      className={styles.dropdown_wrapp}
    >
      <search className={styles.search}>
        <input
          className={styles.search_input}
          type="text"
          value={value}
          onChange={(e) => setInputValue(e.target.value)}
        />
        <IoSearch className={styles.search_icon} />
      </search>
      <ul className={styles.dropdown_list}>
        {filteredChats.map((item) => (
          <SearchDropdownItem
            objectData={item}
            handleSelectItem={handleSelectItem}
            setShowBtn={setShowBtn}
          />
        ))}
      </ul>
    </div>
  );
};

export default SearchDropdown;
